import React from 'react'

import { connect } from 'react-redux';


import { Card, CardBlock, CardTitle , Button , Dropdown , DropdownToggle, 
  DropdownMenu, DropdownItem,Input
} from 'reactstrap';

import ReactTable from "react-table";
import "react-table/react-table.css";

import * as actions from  '../../../actions/factura';

import _ from "lodash";

import {API_URL,api}  from '../../../actions/_request';
import Menu from '../menu.js';

// import ModalInventario from './inventarioFisicoModal.js'
// import ModalHistoricos from './inventarioFisicoHistoricos.js'

import IconEdit from 'react-icons/lib/md/edit';
import IconPrint from 'react-icons/lib/fa/print';
import IconForms from 'react-icons/lib/fa/wpforms';
import IconTimbrar from 'react-icons/lib/fa/check-square-o';
import FaEnvelopeO from 'react-icons/lib/fa/envelope-o';
import IconBan from "react-icons/lib/fa/ban";
import IconsNote  from "react-icons/lib/fa/paperclip";
import IconsRepeat  from "react-icons/lib/fa/repeat";

import IconList from 'react-icons/lib/fa/list-alt';

import IconHistorico from 'react-icons/lib/fa/archive';

import swal from 'sweetalert2';
import ModalCorreo from '../../../components/facturarTicket/ModalCorreo';
import ModalCancelacion from '../../../components/ModalCancelacion';
import ModalNota from '../../../components/facturarTicket/ModalNota';
import ModalReportes from '../../../components/facturarTicket/ModalReportes';

const requestData = (pageSize, page, sorted, filtered,filtro) => {    
    return new Promise((resolve, reject) => {
        // You can retrieve your data however you want, in this case, we will just use some local data.
        let filteredData ;


        /* Campos para filtrar */
        var concepto='';
        var fecha='';
        var factura='';
        var cliente = '';
        /*  */
        var take= pageSize;
        var skip=pageSize * page;
        var total=1;  
        for (var i = filtered.length - 1; i >= 0; i--) {
          switch(filtered[i].id)
          {
            case "fecha":
              fecha=filtered[i].value;
              break;
            case "factura":
              factura=filtered[i].value;
              break;            
            case "concepto":
              concepto=filtered[i].value;
              break;
            case "cliente":
              cliente=filtered[i].value;
            break;         
          }
        }
        api().get(`/facturas_cliente/conteo?filtro=${filtro}&concepto=${concepto}&fecha=${fecha}&cliente=${cliente}&factura=${factura}&take=${take}&skip=${skip}`)
        .then(function(response)
        {
            if(response.status === 200)
            {
              total= response.data[0].total; 
              api().get(`/facturas_cliente/busqueda?filtro=${filtro}&concepto=${concepto}&fecha=${fecha}&cliente=${cliente}&factura=${factura}&take=${take}&skip=${skip}`)
              .then(function(response)
              {
                if(response.status === 200)
                {
                  filteredData= response.data; 
                  // You can also use the sorting in your request, but again, you are responsible for applying it.
                  const sortedData = _.orderBy(
                    filteredData,
                    sorted.map(sort => {
                      return row => {
                        if (row[sort.id] === null || row[sort.id] === undefined) {
                          return -Infinity;
                        }
                        return typeof row[sort.id] === "string"
                        ? row[sort.id].toLowerCase()
                        : row[sort.id];
                      };
                    }),
                    sorted.map(d => (d.desc ? "desc" : "asc"))
                  );
                  const res = {
                    rows: sortedData,
                    pages: Math.ceil(total / pageSize)
                  };
                  // Here we'll simulate a server response with 500ms of delay.
                  //setTimeout(() => resolve(res), 1000);
                  console.log('data--->',res);
                  resolve(res)
                }
              });   
            }
        });
    });
};

class InvoiceModule extends React.Component{
  constructor(props) {
        super(props);
        this.state = {
            modal       : false,
            prospectoid : null,
            title       : "",
            modalHistoricos : false,
            data: [],
            pages: null,
            loading: true,

            seleccion_id : '',             
            kardexModal : false,
            opcionConsulta : 0,
            modal_reportes:false,
            consulta:0,

            modal_correo:false,
            modal_nota:false,
            modal_cancelacion:false,
            factura:0,
            cliente:0,
            filtro:0,
            recargar:true,
        };
        this.toggle       = this.toggle.bind(this);
        this.fetchData = this.fetchData.bind(this);
        


        this.handleChangecheckbox       = this.handleChangecheckbox.bind(this);
        this.toggle_drop       = this.toggle_drop.bind(this);
        this.toggleKardex  = this.toggleKardex.bind(this);
        this.timbrar  = this.timbrar.bind(this);
        this.cancelar  = this.cancelar.bind(this);
        this.toggle_correo  = this.toggle_correo.bind(this);
        this.toggle_nota  = this.toggle_nota.bind(this);
        this.recargar2 = this.recargar2.bind(this);
        this.handleSelectChange = this.handleSelectChange.bind(this);
        this.toggle_reportes  = this.toggle_reportes.bind(this);
    }

    cambiar_tipo_venta(factura) {
      let objeto={
            id:factura.value,
            tipo_venta:0,
        };

    swal({
      title: 'Seleccione el nuevo Tipo de venta',
      input: 'select',
    inputOptions :
    {
      0 : 'Produccion',
      1  : 'Proyecto',
      
    },
      showCancelButton: true,
      confirmButtonText: 'Cambiar',
       cancelButtonText: 'Atras',
      showLoaderOnConfirm: true,
      preConfirm: (motivo) => {

      
        objeto.tipo_venta=motivo;
          return api().post(`/full_update_factura/${objeto.id}`, objeto)
          .then(response => response)
          .catch( error => { swal.showValidationError(`Request failed ${error}`); });
        
      },
      allowOutsideClick: () => !swal.isLoading(),
       }).then((result) => {

      if (result.value) {
        if (result.value.status === 200) {
          swal("Bien hecho!", "Se Cambio el Tipo de venta Correctamente!", "success");
        }
      }

    });

   
    
  }

    handleSelectChange(select, name,tipo=0) {;
      let value=null;
        if(tipo==0){
           value = select === null ? null : select.target.value;
        }else{
           value = select === null ? null : select.value;
        }
     
        this.setState({[name] : value,
                        recargar:false,
                        data:[],
                      });

    }
     recargar2(){
        this.setState({
          recargar:true,
      });
    }

     toggle_cancelacion=(evt,factura=[])=>{ 
        // evt.preventDefault();
         console.log('factura--->',factura);
        this.setState({
              modal_cancelacion : !this.state.modal_cancelacion, 
              factura : factura,
          });
    }
    toggle_nota(evt,factura=[]){ 
        // evt.preventDefault();
         console.log('factura--->',factura);
        this.setState({
              modal_nota : !this.state.modal_nota, 
              factura : factura,
          });
    }
    toggle_correo(evt=[],factura=[]){ 

        // console.log('factura--->',factura);
        this.setState({
              modal_correo : !this.state.modal_correo, 
              factura : factura.value,
              cliente : factura.cliente_id,
          });
    }
    toggle_reportes(evt,consulta=0){ 

        // console.log('factura--->',factura);
        this.setState({
              modal_reportes : !this.state.modal_reportes, 
              consulta:consulta,
          });
    }

    retorno_cancelacion=(factura)=>{
       let self = this;
         this.setState({modal_cancelacion:false}, () => {  self.props.timbrar(factura); });
    }
     cancelar(evt, factura){
      // console.log('Factura------>',factura)
      let self = this;
      this.toggle_cancelacion(evt,factura);
    }
    cancelar_sin_timbrar(evt, factura){
      // console.log('Factura------>',factura)
      let self = this;
      swal.queue([{
        title: 'Estas seguro?',
        text: "Se Cacelara el Documento "+factura.factura+" para "+factura.cliente+' Por la cantidad de '+factura.total,
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Estoy Seguro!',
        cancelButtonText: 'Cancelar!',
        showLoaderOnConfirm: true,
        preConfirm: () => {
          return api().get('/cancelar_sin_timbrar/'+factura.value)
            .then(function(response)
            {    
                // console.log('response-->',response)    
                if(response.status === 200)
                {
                  // console.log('entor al status 200');
                  // console.log('factura-->',response.data.factura) ;
                  if(parseInt(response.data.estado)==200){
                     self.props.timbrar(response.data.factura);
                  }
                   if(parseInt(response.data.estado)==210){
                     swal.insertQueueStep({
                      type: 'error',
                      title: 'el Documento Cuenta Con Abonos'
                    })
                  }
                 
                }
            })
            .catch(() => {
              swal.insertQueueStep({
                type: 'error',
                title: 'Solicitar ayuda a un Administrador'
              })
            })
        }
      }])
    }
    timbrar(evt, factura){
      // console.log('Factura------>',factura)
      let self = this;
      swal.queue([{
        title: 'Estas seguro?',
        text: "Se Timbrara la factura para "+factura.cliente+' Por la cantidad de '+factura.total,
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Estoy Seguro!',
        cancelButtonText: 'Cancelar!',
        showLoaderOnConfirm: true,
        preConfirm: () => {
          return api().get('/timbrar_factura/'+factura.value+'/I')
            .then(function(response)
            {    
                // console.log('response-->',response)    
                if(response.status === 200)
                {
                  

                  if(parseInt(response.data.estado)==200){
                    
                    self.props.timbrar(response.data.factura);
                    
                    window.open(API_URL+'/pdf_factura/'+factura.value+'/I');

                    if(!response.data.vencidas){
                          swal.insertQueueStep({
                        type: 'error',
                        title: 'Se Timbro con Exito la factura , pero el cliente cuenta con Facturas vencidad'
                      })
                    }



                  }else{
                    console.log('Mensaje de error--->',response.data.mensaje)
                    swal.insertQueueStep({
                        type: 'error',
                        title: response.data.mensaje
                      })

                   }
                }
            })
            .catch(() => {
              swal.insertQueueStep({
                type: 'error',
                title: 'Solicitar ayuda a un Administrador'
              })
            })
        }
      }])
    }



  toggle_drop(menu,id) {
    let valor=0;

    if(menu===1){
      if(parseInt(this.state.menu)!==id)
        valor=id;
        this.setState({
          menu: valor
        });
    }else{
      if(parseInt(this.state.submenu)!==id)
        valor=id;
        this.setState({
          submenu: valor
        });
    }
  }

  handleChangecheckbox(row)
  {
    let bandera=0;
    this.setState({
      seleccion_id : parseInt( row.original.value),
      seleccion_label : row.original.label,
    });  
  }


  toggleKardex(evt, opcion, title = "Cargos / Abonos")
    {
      let self = this;
      let {seleccion_id} = this.state;
      if(seleccion_id == ''&&opcion==6)
      {
         swal("Oops..", "Por favor Seleccione una Factura");
        return
      }

      if(seleccion_id !== ''||opcion!=1||opcion!=4){
        // 
        let {modal_reportes} = this.state;
        let {consulta} = this.state;

        consulta = opcion;
        switch(parseInt (opcion)){
          case 1 : 
           window.open(`${API_URL}/abonosFacturaCliente/${this.state.seleccion_id}`)
           break;
         case 6 : 
          swal.queue([{
          title: 'Estas seguro?',
          text: "Se Calculara el saldo de la factura ",
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Estoy Seguro!',
          cancelButtonText: 'Cancelar!',
          showLoaderOnConfirm: true,
          preConfirm: () => {
            return api().get('/factura_recalcular/'+this.state.seleccion_id+'')
              .then(function(response)
              {    
                  // console.log('response-->',response)    
                  if(response.status === 200)
                  {
                    

                    if(parseInt(response.data.estado)==200){
                      
                     
                      
                    

                          self.props.actualizar_renglon(response.data.factura);
                          swal.insertQueueStep({
                          type: 'success',
                          title: "Se Calculo Con Exito el Saldo del Documento"
                        })
                      



                    }else{
                      console.log('Mensaje de error--->',response.data.mensaje)
                      swal.insertQueueStep({
                          type: 'error',
                          title: response.data.mensaje
                        })

                     }
                  }
              })
              .catch(() => {
                swal.insertQueueStep({
                  type: 'error',
                  title: 'Solicitar ayuda a un Administrador'
                })
              })
          }
        }])
           break;
            case 4 : 
                this.props.history.push('/invoiceModule/reporte/facturas_dia');
           break;
           default: 
             this.setState({
                  modal_reportes       : !modal_reportes,
                  title       : title,
                  consulta : consulta
              });
           break;

        }
        
      }else{
          swal("Oops..", "Por favor Seleccione una Factura");
      }
    }

 liberar_ticket=(evt,factura)=>{

      let self = this;
      // console.log('factura--->',factura)
      swal.queue([{
        title: 'Estas seguro?',
        text: "Se Timbrara la factura para "+factura.cliente+' Por la cantidad de '+factura.total,
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Estoy Seguro!',
        cancelButtonText: 'Cancelar!',
        showLoaderOnConfirm: true,
        preConfirm: () => {
          return api().get('/quitar_ticket_factura/'+factura.value+'')
            .then(function(response)
            {    
                // console.log('response-->',response)    
                if(response.status === 200)
                {
                  

                  if(parseInt(response.data.estado)==200){
                    
                   
                     self.props.timbrar(response.data.factura);
                  

                    
                        swal.insertQueueStep({
                        type: 'success',
                        title: response.data.mensaje
                      })
                    



                  }else{
                    console.log('Mensaje de error--->',response.data.mensaje)
                    swal.insertQueueStep({
                        type: 'error',
                        title: response.data.mensaje
                      })

                   }
                }
            })
            .catch(() => {
              swal.insertQueueStep({
                type: 'error',
                title: 'Solicitar ayuda a un Administrador'
              })
            })
        }
      }])





 }

   

    fetchData(state, instance) {
    // Whenever the table model changes, or the user sorts or changes pages, this method gets called and passed the current table model.
    // You can set the `loading` prop of the table to true to use the built-in one or show you're own loading bar if you want.
    this.setState({ loading: true });
    // Request the data however you want.  Here, we'll use our mocked service we created earlier
    requestData(
      state.pageSize,
      state.page,
      state.sorted,
      state.filtered,
      this.state.filtro,
    ).then(res => {
      // Now just get the rows of data to your React Table (and update anything else like total pages or loading)
      this.setState({
        data: res.rows,
        pages: res.pages,
        loading: false
      });
      this.props.get(res.rows);
    });
  }

  toggle(evt, prospectoid = null, title = "Agregar Inventario Fisico")
    {
        let {modal} = this.state;

        this.setState({
            modal       : !modal,
            prospectoid : prospectoid,
            title       : title,
            
        });
    }
   

    render(){
      let permisos_modulos= this.props.auth.permisos[6];
      // console.log('permisos--->',permisos_modulos);
      
      const { data, pages, loading ,recargar} = this.state;
      // console.log(this.props.inventarioFisico.data)
      if(recargar==false)
          setTimeout(this.recargar2() , 3);
      return(

        <div className="view">
              <Menu props={this.props}/>
                <div className="view-header">
                    <header className="title text-white">
                        <h1 className="h4 text-uppercase">Lista de Facturas </h1>
                    </header>
                </div>
              <div className="view-content view-components">
                    <Card>
                        <CardBlock>
                        <div className="col text-left">
                            <Dropdown nav className='btn-sm info' color="" isOpen={parseInt(this.state.menu)===1?true:false} toggle={() => {this.toggle_drop(1,1);}} >
                              <DropdownToggle nav caret>
                               <IconForms/>Consultas
                              </DropdownToggle>
                              <DropdownMenu className='letras_menu'>
                                <DropdownItem onClick={(e) => this.toggleKardex(e,1,'Cargos / Abonos')}>Cargos / Abonos</DropdownItem>
                                <DropdownItem onClick={(e) => this.toggleKardex(e,6,'Recalcular Saldo')}>Recalcular Saldo</DropdownItem>
                                 <DropdownItem onClick={(e) => this.toggleKardex(e,2,'Facturas de Clientes Contadora')}>Facturas de Clientes Contadora</DropdownItem>
                                 <DropdownItem onClick={(e) => this.toggleKardex(e,3,'Facturas de Clientes Cobranza')}>Facturas de Clientes Cobranza</DropdownItem>
                                  <DropdownItem onClick={(e) => this.toggleKardex(e,5,'Facturas de Clientes por Tipo')}>Facturas de Clientes por Tipo</DropdownItem>
                                 <DropdownItem onClick={(e) => this.toggleKardex(e,4,'Facturas del Dia')}>Facturas del Dia</DropdownItem>

                              </DropdownMenu>
                            </Dropdown>
                          </div>
                          <div className="text-right">
                          <div className="row">
                          <div className="col-md-6"> </div>
                        <div className="col-md-3"> 
                                    <div className="form-group">
                                      <Input type="select" 
                                        name="filtro" 
                                        id="filtro" 
                                        value={this.state.filtro} 
                                        onChange={(e) => this.handleSelectChange(e,'filtro')} >
                                        <option value={0}>Todas</option>
                                        <option value={1}>Con Saldo</option>
                                        <option value={2}>Vencidas mas de 15 Dias</option>
                                        <option value={3}>Vencidas mas de 30 Dias</option>
                                      </Input>
                                  </div>
                        </div>

                        <div className="col-md-3"> 
                          <div className="form-group">
                            {' '}
                            <Button color="success" className="mb-2" onClick={() => { this.props.history.push('/invoiceModule/form');}}>
                              {<IconList/>}&nbsp;Agregar
                            </Button>
                          </div>
                        </div>
                    </div>
                          </div>
                           {(recargar==true)&& <ReactTable
                              getTrProps={(state, rowInfo, column) => {
                                  
                                  if(rowInfo === undefined){
                                         
                                    return{
                                      }
                                    } else{
                                      return{
                                        onDoubleClick: (e) => {
                                          if(parseInt(rowInfo.original.timbrado)==0){
                                            this.props.history.push('/invoiceModule/edit/'+rowInfo.original.value);
                                          }else{
                                            if(parseInt(rowInfo.original.importada)==0){
                                            swal('', 'Factura Timbrada no se puede editar');
                                            }else{
                                              this.props.history.push('/invoiceModule/importar/'+rowInfo.original.value);
                                            }
                                          }
                                        }
                                      }
                                    }
                              }}
                              className = "-striped -highlight"
                              columns   = {[
                                 {
                                    Header: 'Seleccion',
                                    filterable: false,
                                    sortable: false,
                                    maxWidth:80,
                                    minWidth:80, 
                                    Cell: (row) =>
                                    {
                                        return(
                                            <div className="text-center">
                                                <input type="checkbox"
                                                name="" 
                                                checked={(this.state.seleccion_id === parseInt( row.original.value)) ? true : false}
                                                onChange={() => this.handleChangecheckbox(row)}/>                                                 
                                            </div>
                                        )
                                    }
                                },{
                                    Header: 'Controles',
                                    filterable: false,
                                    sortable: false,
                                    minWidth:250,
                                    Cell: (row) =>
                                    {
                                        return(
                                            <div className="text-center">

                                            
                                            {
                                              (parseInt(row.original.timbrado)==0&&parseInt(row.original.tipo_doc)==1&&parseInt(row.original.cancelado)==0)&&
                                              <Button
                                                 color="success" 
                                                  title=" Timbrar Facturar"
                                                 onClick={(evt)=>this.timbrar(evt, row.original)}>
                                                    <IconTimbrar />
                                                </Button>
                                            }
                                            {' '}
                                            {
                                              (parseInt(row.original.timbrado)==1&&parseInt(row.original.cancelado)==0&&parseInt(row.original.tipo_doc)==1&& parseInt(permisos_modulos.bajas)==1)&&
                                              <Button
                                                 color="danger" 
                                                  title=" Cancelar Facturar(Timbrado)"
                                                 onClick={(evt)=>this.cancelar(evt, row.original)}>
                                                    <IconBan />
                                                </Button>
                                            }
                                            {' '}
                                            {
                                              (parseInt(row.original.timbrado)==0&&parseInt(row.original.cancelado)==0&&parseInt(row.original.tipo_doc)==1&& parseInt(permisos_modulos.bajas)==1)&&
                                              <Button
                                                 color="warning" 
                                                  title=" Cancelar Facturar ( Sin Timbrado)"
                                                 onClick={(evt)=>this.cancelar_sin_timbrar(evt, row.original)}>
                                                    <IconBan />
                                                </Button>
                                            }
                                            {
                                              (parseInt(row.original.timbrado)==0&&parseInt(row.original.cancelado)==0&&parseInt(row.original.tipo_doc)==2&& parseInt(permisos_modulos.bajas)==1)&&
                                              <Button
                                                 color="warning" 
                                                  title=" Cancelar Remision"
                                                 onClick={(evt)=>this.cancelar_sin_timbrar(evt, row.original)}>
                                                    <IconBan />
                                                </Button>
                                            }
                                                     
                                                {' '}
                                                 {(parseInt(row.original.tipo_doc)==1&&parseInt(row.original.importada)==0&&parseInt(row.original.timbrado)==1)&&
                                                  <a href={API_URL+"/pdf_factura/"+row.original.value+'/I'} target="_blank">
                                                      <Button color="secondary" title=" Imprimir Facturar" >
                                                          <IconPrint  />
                                                      </Button>
                                                  </a>
                                                }
                                                {(parseInt(row.original.tipo_doc)==2&&parseInt(row.original.importada)==0)&&
                                                  <a href={API_URL+"/pdf_remision/"+row.original.value} target="_blank">
                                                      <Button color="secondary" title=" Imprimir Remision" >
                                                          <IconPrint  />
                                                      </Button>
                                                  </a>
                                                }
                                                {' '}
                                                {
                                                  (parseInt(row.original.timbrado)==0&&parseInt(row.original.importada)==0&&parseInt(row.original.cancelado)==0)&&
                                                <Button
                                                 color="success" 
                                                 title=" Editar Documento"
                                                 onClick={(evt)=>this.props.history.push('/invoiceModule/edit/'+row.original.value)}>
                                                    <IconEdit />
                                                </Button> 

                                              }
                                              {
                                                  (parseInt(row.original.importada)==1&&parseInt(row.original.cancelado)==0)&&
                                                <Button
                                                 color="success" 
                                                  title=" Editar Documento"
                                                 onClick={(evt)=>this.props.history.push('/invoiceModule/importar/'+row.original.value)}>
                                                    <IconEdit />
                                                </Button> 

                                              }
                                              {' '}
                                              {(parseInt(row.original.tipo_doc)==1&&parseInt(row.original.importada)==0&&parseInt(row.original.timbrado)==1)&&
                                                <Button color={parseInt(row.original.enviada)==1?"info":"secondary"}
                                                 title=" Enviar Facturar"
                                                 onClick={(evt)=>this.toggle_correo(evt, row.original)}>
                                                  <FaEnvelopeO />
                                                </Button>

                                              }
                                              {' '}
                                              <Button color="warning"
                                                 title="Nota"
                                                 onClick={(evt)=>this.toggle_nota(evt, row.original)}>
                                                  <IconsNote />
                                                </Button>
                                                 {' '}
                                                <Button color="info"
                                                 title="Cambio de Tipo de Venta"
                                                 onClick={(evt)=>this.cambiar_tipo_venta( row.original)}>
                                                  <IconsRepeat />
                                                </Button>
                                              
                                            </div>
                                        )
                                    }
                                },
                                {Header: 'Estado', accessor: 'estado',maxWidth:150,minWidth:150 , style: { 'textAlign': 'center'}},
                                {Header: 'Factura', accessor: 'factura',maxWidth:150,minWidth:150 , style: { 'textAlign': 'center'}},
                                {Header: 'Fecha', accessor: 'fecha',maxWidth:150,minWidth:150 , style: { 'textAlign': 'center'}},
                                {Header: 'Concepto', accessor: 'concepto'},
                                {Header: 'Cliente', accessor: 'cliente', minWidth:350,},
                                {Header: 'Total', accessor: 'total',maxWidth:150,minWidth:150 , filterable: false, sortable: false, style: { 'textAlign': 'center'}},
                                {Header: 'Saldo', accessor: 'saldo' ,maxWidth:150,minWidth:150 , filterable: false, sortable: false, style: { 'textAlign': 'center'}},
                                
                              
                              ]}
                            
                              manual // Forces table not to paginate or sort automatically, so we can handle it server-side
                              data={this.props.factura.data}
                              pages={pages} // Display the total number of pages
                              loading={loading} // Display the loading overlay when we need it
                              onFetchData={_.debounce(this.fetchData, 500)} // Request new data when things change
                              filterable
                              defaultPageSize={10} 
                              SubComponent={ row => {
                                return(
                                    <Card>
                                        <CardBlock>
                                            <CardTitle className="h6 text-uppercase mb-4">Más Información</CardTitle>
                                            <div className='row'>
                                              <div className='mb-4'>
                                                {
                                              (parseInt(row.original.timbrado)==1&&parseInt(row.original.tipo_doc)==1&&parseInt(row.original.cancelado)==0)&&
                                              <Button
                                                 color="success" 
                                                  title=" Liberar Ticket de la Factura"
                                                 onClick={(evt)=>this.liberar_ticket(evt, row.original)}>
                                                    Liberar Ticket de la Factura
                                                </Button>
                                            }
                                              </div>
                                              <div className='col-12'>
                                                <h1 className="h4 text-uppercase">Nota:</h1>
                                              </div>
                                              <div className='col-12'>
                                                <p className=" text-uppercase">{row.original.nota_interna} </p>
                                              </div>
                                            </div> 
                                            <table className="table">
                                              <thead>
                                                <tr>
                                                  <th>Controles</th>
                                                  <th>Ticket</th>
                                                  <th>Codigo</th>
                                                  <th>Descripción</th> 
                                                  <th>Cantidad</th>
                                                  <th>Total</th>                                                 
                                                </tr>
                                              </thead>
                                              <tbody>
                                                {
                                                  row.original.productos.map((item, i) => 
                                                  <tr key={i}>
                                                   <td><a href={API_URL+"/ticketsv2/printTicketFinal/"+item.ticket_id} target="_blank">
                                                      <Button color="secondary" title=" Imprimir Ticket" >
                                                          <IconPrint  />
                                                      </Button>
                                                  </a></td>
                                                   <td>{item.clave_ticket}</td>
                                                   <td>{item.codigo_item}</td>
                                                   <td>{item.descripcion_item}</td>
                                                   <td>{item.cantidad}</td>
                                                   <td>{item.total}</td>  
                                                  </tr>)
                                                }
                                              </tbody>
                                            </table>
                                        </CardBlock>
                                    </Card>
                                )
                              }}
                             
                            />
                          }
                        </CardBlock>
                    </Card>
                </div>
                { this.state.modal_correo&&
                    <ModalCorreo
                        open={this.state.modal_correo}
                        toggle={this.toggle_correo}  
                        cliente={this.state.cliente} 
                        factura={this.state.factura}
                    />
                }
                { this.state.modal_nota&&
                    <ModalNota
                        open={this.state.modal_nota}
                        toggle={this.toggle_nota}  
                        documento={this.state.factura}
                    />
                }

                { this.state.modal_cancelacion&&
                    <ModalCancelacion
                        open={this.state.modal_cancelacion}
                        toggle={this.toggle_cancelacion}  
                        documento={this.state.factura}
                        tipo={'Factura'}
                        ruta={'cancelar_factura'}
                        retorno={this.retorno_cancelacion}
                    />
                }
                {
                   this.state.modal_reportes&& 
                   <ModalReportes 
                 open={this.state.modal_reportes} 
                 toggle={this.toggle_reportes} 
                 title={this.state.title} 
                 consulta={this.state.consulta}
                />
                }
             
              
            </div>

      )
    }
}

function mapStateToProps(state, ownProps) {
    return {
        factura : state.factura,
        auth:state.auth,
    }
};
export default connect(mapStateToProps, actions)(InvoiceModule)


// WEBPACK FOOTER //
// ./src/views/facturacion/invoiceModule/tablaInvoice.js